<template>
  <div id="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "app",
};
</script>

<style>

@font-face {
    font-family: ProbaPro;
    src: url('assets/fonts/probapro-regular.ttf')
  }

  @font-face {
    font-family: ProbaProBold;
    src: url('assets/fonts/probapro-bold.ttf');
  }

</style>